import React from 'react';
import { Redux, Slices } from 'spwa-ui-library';
import { useNavigate, useLocation } from '@reach/router';
import { useIntl, FormattedMessage } from 'react-intl';
import { decimalChecker, isProductCustomized } from 'spwa-ui-library/esm/utils/helper';
import { BiRightArrowAlt } from '@react-icons/all-files/bi/BiRightArrowAlt';
import { TiTick } from '@react-icons/all-files/ti/TiTick';
import css from './index.module.scss';
import ClassNames from 'classnames';
import { Button } from '@material-ui/core';
import { generateProductRoute } from 'spwa-ui-library/esm/utils/path';

const { useSelector, useDispatch } = Redux;
const { selectDesktop } = Slices.appSlice;
const { getClusterId } = Slices.configSlice;
const { selectDefaultAddress } = Slices.addressSlice;
const {
  setStatus,
  setDetailsFetched,
  getProductInfo,
  selectProductEntities,
  fetchProductsByCategoryId,
  addNewProduct,
} = Slices.productSlice;
const { addProductToCustomize, updateProductPayload, addPayloadToTempData } = Slices.tempCartSlice;

export default function ProductTilePrice({
  name,
  keyVal,
  currency,
  price = 0,
  strikeOutPrice,
  discountPercentage,
  productId,
  categoryId,
  productRoute,
  hideCustomize,
  returnURL,
  productObj,
  mainProductId,
  isBundleItem,
  currentStepperId,
  oldLocation,
  setShowCustomizeProductDialog,
  setShowBundleGroupDialog,
  buildCat,
}) {
  const intl = useIntl();
  const location = useLocation();
  const locationSearch = new URLSearchParams(location.search);

  const showStrike = strikeOutPrice > price;
  const isDesktop = useSelector(selectDesktop);
  const defaultAddress = useSelector(selectDefaultAddress);
  const tempItems = useSelector((state) => state.tempCart);
  const categoryList = useSelector((state) => state.category);
  const cartItems = useSelector((state) => state.cart);
  const productsMap = useSelector(selectProductEntities);
  const clusterId = useSelector(getClusterId);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  let finalCartItem = cartItems.data.items.filter((product) => product?.id == productObj?.id);

  if (finalCartItem.length > 0) {
    finalCartItem = finalCartItem[finalCartItem.length - 1];
  }

  //TODO: Use this logic in future for pizza category
  // const tempCartProduct =
  //   tempItems.customize.items.filter((product) => (product?.id == productObj?.id && !product?.notAdded))?.length > 0;

  const tempCartProduct =
    tempItems.customize.items.filter((product) => product?.id == productObj?.id)?.length > 0;

  const tempCartProd =
    tempItems.customize.items.filter(
      (product) => product?.id == productObj?.id && !product?.notAdded
    )?.length > 0;

  let isCustomized =
    tempCartProd &&
    isProductCustomized(
      productObj,
      tempItems.customize.items.find((product) => product?.id == productObj?.id)
    );

  let prodCust = tempItems.customize.items.find((product) => product?.id == productObj?.id);
  if (prodCust && productObj?.typeId == 'simple' && productObj?.bundleTypeId == 'bundle') {
    isCustomized = !prodCust?.isDefault;
  }

  let bundleGroupCartItems = cartItems.data.items.filter(
    (product) =>
      product?.additionalInfo?.bundleGroupId == productObj?.id || product?.catId == productObj?.id
  );

  if (productObj?.bundleTypeId == 'bundle_group' && bundleGroupCartItems?.length > 0) {
    isCustomized = true;
  }

  let isProductInCart =
    cartItems.data.items.filter((product) => product?.id == productObj?.id)?.length > 0;

  if (isBundleItem) {
    const productCustomization = tempItems.data.items.find(
      (product) => product.id == mainProductId
    );

    let allProducts = [];
    for (let [sId, step] of Object.entries(productCustomization?.['bundle'] || {})) {
      for (let [pId, pObj] of Object.entries(step)) {
        allProducts = [...allProducts, { ...pObj, id: pId, sId: sId }];
      }
    }

    let matches = allProducts?.filter((item) => item.id == productObj.id && !item?.notAdded) || [];
    let actualMatches = [];
    for (let match of matches) {
      let doesVariationExist = true;
      for (let [variantId, selectedVariant] of Object.entries(match?.variants || {})) {
        // check if this combo exists in productObj or not
        let currentVariation = productObj?.variants?.find((v) => v.id == variantId);
        let currentSelectedVariation = currentVariation?.options?.find(
          (cv) => cv.id == selectedVariant
        );

        if (!currentSelectedVariation) {
          doesVariationExist = false;
        }
      }

      if (doesVariationExist) {
        actualMatches.push(match);
      }
    }

    const isLastDefault = actualMatches[actualMatches.length - 1]?.isDefault;

    isCustomized =
      actualMatches.length > 0 &&
      !isLastDefault &&
      !productCustomization?.['bundle']?.[currentStepperId]?.[productObj?.id]?.['notAdded'] &&
      Object.keys(actualMatches[actualMatches.length - 1]?.items || {}).length > 0 &&
      isProductCustomized(productObj, actualMatches[actualMatches.length - 1]);
  }

  const itemExistsInCart = () => {
    let data = tempItems?.customize?.items?.find(
      (item) => item.id == (mainProductId || productObj.id)
    );

    return (
      !!data && (!!data['items'] || !!data['bundle'] || !!data['subItem']) && data?.isCustomized
    );
  };

  const handleHomePageItem = () => {
    dispatch(
      fetchProductsByCategoryId({
        cluster: clusterId,
        categoryId: productObj?.categories[0],
        Language: intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1),
      })
    ).then((p) => {
      dispatch(
        getProductInfo({
          id: productObj?.id,
          cluster: clusterId,
          service: defaultAddress?.addressSubType || 'DELIVERY',
          categoryId: productObj?.categories[0],
          Language: intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1),
        })
      ).then((resp) => {
        let productData;
        if (resp?.payload?.id) {
          dispatch(addNewProduct(resp.payload));
          productData = resp.payload;
        } else {
          productData = productObj;
        }
        let category = {};
        let locale = intl.locale;
        let productRoute = '';
        category = categoryList.entities[productData?.categories?.[0]];
        productRoute = generateProductRoute({ product: productData, category, locale });

        if (
          (productData?.bundleTypeId === 'bundle' ||
            productData?.bundleTypeId === 'bundle_group') &&
          productData?.typeId != 'simple'
        ) {
          productRoute = `${productRoute}/bundle`;
        }
        dispatch(
          addProductToCustomize({
            productType: productData?.bundleTypeId,
            updatedOn: new Date().getTime(),
            mainProductId: productData?.id,
            data: {
              ...productData,
              noIncrement: true,
            },
          })
        );
        navigate(productRoute, {
          state: {
            retUrl: `/${intl.locale}/home/`,
            oldLocation: location,
            description: `${productObj?.name || productObj?.title || ''}`,
          },
        });
      });
    });
  };

  const handleRoute = (e) => {
    e.preventDefault();

    if (productObj?.isHomePageItem) {
      handleHomePageItem();
      return;
    }

    if (buildCat && itemExistsInCart()) {
      setShowCustomizeProductDialog(mainProductId || productObj.id);
      return;
    }

    if (!isCustomized && !isBundleItem) {
      console.log(`removing unlockedStepperId 2`);
      window.localStorage.removeItem('unlockedStepperId');
    }

    window.localStorage.setItem('notShowBogoPopup', true);

    dispatch(setStatus('loading'));

    if (productsMap[mainProductId]?.isBOGO && locationSearch.has('option')) {
      categoryId = locationSearch.get('option');
    }

    const customizedProducts = tempItems?.customize?.items.filter(
      (item) => item.id == (isBundleItem ? mainProductId : productObj.id)
    );
    const notAddedCustomizedProducts = tempItems?.customize?.items.filter(
      (item) => item.id == (isBundleItem ? mainProductId : productObj.id) && item?.notAdded
    );

    let mainProductObj = productsMap[mainProductId || productId];
    let bundleId;
    if (mainProductObj?.typeId == 'bundle_group') {
      if (customizedProducts?.[0]?.additionalInfo?.selectedBundleId) {
        bundleId = customizedProducts?.[0]?.additionalInfo?.selectedBundleId;
      } else if (mainProductObj?.isBOGO) {
        let steps = Object.keys(customizedProducts?.[0]?.bundle || {});
        steps = steps?.[steps.length - 1] || [0];
        bundleId = (steps - (steps % 10)) / 10;
      }

      if (bundleId && !isBundleItem) {
        productRoute = `${productRoute}?bundleGroup=1&option=${bundleId}`;
      }
    }

    dispatch(
      getProductInfo({
        id: bundleId && !mainProductObj?.isBOGO ? bundleId : productId,
        cluster: clusterId,
        service: defaultAddress?.addressSubType || 'DELIVERY',
        categoryId:
          categoryId == 999
            ? productObj?.categories?.[0] || mainProductObj?.categories?.[0]
            : categoryId,
        Language: intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1),
      })
    ).then((resp) => {
      dispatch(setDetailsFetched(true));

      if (!isCustomized && customizedProducts.length == 0 && !locationSearch.has('cartId')) {
        dispatch(
          addProductToCustomize({
            productType: productObj.bundleTypeId,
            updatedOn: new Date().getTime(),
            mainProductId: productObj.id,
            data: isBundleItem
              ? {
                  ...productsMap[mainProductId],
                  category:
                    categoryId == 999
                      ? productObj?.categories?.[0] || mainProductObj?.categories?.[0]
                      : categoryId,
                  noIncrement: true,
                }
              : {
                  ...resp.payload,
                  category:
                    categoryId == 999
                      ? productObj?.categories?.[0] || mainProductObj?.categories?.[0]
                      : categoryId,
                  noIncrement: true,
                },
          })
        );
      } else if (tempCartProduct && !isBundleItem) {
        // add default items if notAdded: true
        let customization = JSON.parse(JSON.stringify(customizedProducts[0]));
        if (customization?.notAdded && !customization?.items) {
          let defaultItems = {},
            variationArray = [-1, -1, -1],
            currentProductVariation = null;

          Object.values(customization?.variants || {}).forEach((variation, idx) => {
            variationArray[idx] = variation;
          });

          currentProductVariation = resp.payload?.items?.find((item) => {
            let itemInfo;
            if (!item?.id) {
              itemInfo = productsMap[item];
            } else {
              itemInfo = item;
            }

            let isVariantSame = true;
            variationArray.forEach((variant, index) => {
              if (itemInfo[`sel${index + 1}Value`] != variant) {
                isVariantSame = false;
              }
            });
            return isVariantSame;
          });

          if (!currentProductVariation?.id) {
            currentProductVariation = productsMap[currentProductVariation];
          }

          for (let step of currentProductVariation?.steps || []) {
            let optionObj = {};
            for (let option of step?.options || []) {
              if (option?.subOptions) {
                let defaultSubOption = option?.subOptions?.find(
                  (subOption) => subOption?.default == 1
                );
                if (defaultSubOption) {
                  optionObj[option.id] = { qty: 1 };
                }
              } else {
                if (option?.default) {
                  optionObj[option.id] = { qty: 1 };
                }
              }
            }
            if (Object.values(optionObj || {}).length > 0) {
              defaultItems[step.id] = optionObj;
            }
          }

          customization['items'] = defaultItems;
        }

        dispatch(
          addPayloadToTempData({
            id: customization?.id,
            data: { ...customization },
          })
        );
      }

      if (isBundleItem) {
        // update bundle in tempCart data for step -
        const productCustomization = tempItems.data.items.find(
          (product) => product.id == mainProductId
        );

        const newProductCustomization = JSON.parse(JSON.stringify(productCustomization || {}));

        // generate correct object for step ID
        let variants = {},
          itemPayload = { qty: 1 },
          variationArray = [-1, -1, -1];

        let allProducts = [];
        for (let step of Object.values(productCustomization?.['bundle'] || {})) {
          for (let [pId, pObj] of Object.entries(step)) {
            allProducts = [...allProducts, { ...pObj, id: pId }];
          }
        }
        const productMatch = allProducts?.findLast(
          (item) => item.id == productObj.id && !item?.notAdded
        );

        if (productMatch) {
          variants = productMatch?.variants;
          Object.values(variants || {}).forEach((v, i) => {
            variationArray[i] = v;
          });
        } else {
          // eslint-disable-next-line no-unused-expressions
          productObj?.variants?.forEach((variant, index) => {
            const selectedOption = variant?.options.find((option) => option.isSelected == 1);
            if (selectedOption) {
              variants[variant.id] = selectedOption.id;
              variationArray[index] = selectedOption.id;
            }
          });
        }

        itemPayload['variants'] = variants;

        // fix for scenario when we have changed the product variation and need to customize afterwards
        if (
          productCustomization?.['bundle']?.[currentStepperId]?.[productObj?.id]?.['variants'] &&
          productCustomization?.['bundle']?.[currentStepperId]?.[productObj?.id]?.['notAdded']
        ) {
          itemPayload['variants'] =
            productCustomization?.['bundle']?.[currentStepperId]?.[productObj?.id]?.['variants'];
        }

        // contains items such as toppings, add them
        if (
          Array.isArray(productObj?.items) &&
          productObj?.items?.length > 0 &&
          typeof productObj.items[0] == 'object'
        ) {
          let selectedItemIndex = -1;

          if ((productObj?.items?.length || 0) < 2 || productObj?.typeId == 'simple') {
            selectedItemIndex = 0;
          } else {
            // eslint-disable-next-line no-unused-expressions
            productObj?.items?.forEach((item, i) => {
              let areVariationsSame = true;
              variationArray.forEach((value, index) => {
                if (item[`sel${index + 1}Value`] != value) {
                  areVariationsSame = false;
                }
              });

              if (areVariationsSame) {
                selectedItemIndex = i;
              }
            });
          }

          if (selectedItemIndex > -1) {
            let items = {};
            let steps = productObj?.items[selectedItemIndex]?.steps;
            if (!steps?.[0]?.options) {
              steps = resp.payload?.items?.find(
                (item) => item?.id == productObj?.items[selectedItemIndex]?.id
              )?.steps;
            }

            if (isCustomized) {
              items = productMatch?.items || {};
            } else {
              // eslint-disable-next-line no-unused-expressions
              steps?.forEach((step) => {
                items[step.id] = {};
                // eslint-disable-next-line no-unused-expressions
                step?.options?.forEach((option) => {
                  if (option?.subOptions) {
                    const selectedSubOptions = option?.subOptions?.filter(
                      (subOption) => subOption.selected == 1
                    );
                    if (selectedSubOptions?.length > 0) {
                      items[step.id][option.id] = {
                        qty: selectedSubOptions?.length,
                      };
                    }
                  } else {
                    if (option?.selected == 1) {
                      items[step.id][option.id] = {
                        qty: 1,
                      };
                    }
                  }
                });
                if (!Object.keys(items[step.id]).length) delete items[step.id];
              });
            }

            let finalItems = {};
            for (let [keys, vals] of Object.entries(items)) {
              if (vals) {
                finalItems[keys] = vals;
              }
            }

            if (Object.keys(finalItems)?.length) itemPayload['items'] = finalItems;
          }
        }

        if (!newProductCustomization?.['bundle']) {
          newProductCustomization['bundle'] = {};
        }
        if (!newProductCustomization?.['bundle']?.[currentStepperId]) {
          newProductCustomization['bundle'][currentStepperId] = {};
        }
        newProductCustomization['bundle'][currentStepperId][productObj.id] = itemPayload;

        let cartProductItem;
        if (locationSearch.has('cartId')) {
          cartProductItem = tempItems.data.items.find((item) => item?.id == mainProductId);

          let bundleObject = cartProductItem?.items
            ? cartProductItem?.items
            : cartProductItem?.bundle;

          cartProductItem =
            Object.values(bundleObject?.[currentStepperId]?.[productObj?.id] || {}).length > 0
              ? true
              : false;
        }

        let tempProductItem = tempItems.data.items.find((item) => item?.id == mainProductId);

        let tempBundleObject = tempProductItem?.items
          ? tempProductItem?.items
          : tempProductItem?.bundle;

        let isCustomizedBundleItem =
          Object.values(tempBundleObject?.[currentStepperId]?.[productObj?.id] || {}).length > 0
            ? true
            : false;

        if (
          (!locationSearch.has('cartId') || !cartProductItem) &&
          !(isBundleItem && isCustomizedBundleItem)
        ) {
          console.log('xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx');
          newProductCustomization['bundle'][currentStepperId][productObj?.id]['notAdded'] = true;
          dispatch(
            updateProductPayload({
              data: newProductCustomization,
            })
          );
        }

        const productCustomizationObj = JSON.parse(JSON.stringify(productCustomization || {}));

        // remove isDefault from current stepper
        let isDefaultRemoved = false;
        for (let [step, stepInfo] of Object.entries(productCustomizationObj?.bundle || {})) {
          if (step == currentStepperId) {
            for (let [stepProdId, stepProdObj] of Object.entries(stepInfo)) {
              if (productCustomizationObj?.bundle?.[step]?.[stepProdId]?.isDefault) {
                delete productCustomizationObj?.bundle?.[step]?.[stepProdId]?.isDefault;
                isDefaultRemoved = true;
              }
            }
          }
        }

        if (isDefaultRemoved) {
          if (!productCustomizationObj?.bundle?.[currentStepperId]?.[productObj?.id]) {
            productCustomizationObj['bundle'][currentStepperId][productObj?.id] = {};
            // add default variants
            let defaulVariants = {};
            // eslint-disable-next-line no-unused-expressions
            productObj?.variants?.forEach((variant, index) => {
              const selectedOption = variant?.options.find((option) => option.isSelected == 1);
              if (selectedOption) {
                defaulVariants[variant.id] = selectedOption.id;
              }
            });
            productCustomizationObj['bundle'][currentStepperId][productObj?.id][
              'variants'
            ] = defaulVariants;
          }
          if (!productCustomizationObj?.bundle?.[currentStepperId]?.[productObj?.id]?.qty) {
            productCustomizationObj['bundle'][currentStepperId][productObj?.id]['qty'] = 1;
          }

          // add default toppings if not present
          if (
            !Object.keys(
              productCustomizationObj?.bundle?.[currentStepperId]?.[productObj?.id]?.items || {}
            ).length &&
            Array.isArray(productObj?.items) &&
            productObj?.items?.length > 0 &&
            typeof productObj.items[0] == 'object'
          ) {
            let selectedItemIndex = -1;

            if ((productObj?.items?.length || 0) < 2 || productObj?.typeId == 'simple') {
              selectedItemIndex = 0;
            } else {
              if (
                Object.values(
                  productCustomizationObj?.bundle?.[currentStepperId]?.[productObj?.id]?.variants ||
                    {}
                ).length
              ) {
                variationArray = Object.values(
                  productCustomizationObj?.bundle?.[currentStepperId]?.[productObj?.id]?.variants ||
                    {}
                );
              }
              // eslint-disable-next-line no-unused-expressions
              productObj?.items?.forEach((item, i) => {
                let areVariationsSame = true;
                variationArray.forEach((value, index) => {
                  if (item[`sel${index + 1}Value`] != value) {
                    areVariationsSame = false;
                  }
                });

                if (areVariationsSame) {
                  selectedItemIndex = i;
                }
              });
            }

            if (selectedItemIndex > -1) {
              let items = {};
              let steps = productObj?.items[selectedItemIndex]?.steps;
              if (!steps?.[0]?.options) {
                steps = resp.payload?.items?.find(
                  (item) => item?.id == productObj?.items[selectedItemIndex]?.id
                )?.steps;
              }

              if (isCustomized) {
                items = productMatch?.items || {};
              } else {
                // eslint-disable-next-line no-unused-expressions
                steps?.forEach((step) => {
                  items[step.id] = {};
                  // eslint-disable-next-line no-unused-expressions
                  step?.options?.forEach((option) => {
                    if (option?.subOptions) {
                      const selectedSubOptions = option?.subOptions?.filter(
                        (subOption) => subOption.selected == 1
                      );
                      if (selectedSubOptions?.length > 0) {
                        items[step.id][option.id] = {
                          qty: selectedSubOptions?.length,
                        };
                      }
                    } else {
                      if (option?.selected == 1) {
                        items[step.id][option.id] = {
                          qty: 1,
                        };
                      }
                    }
                  });
                  if (!Object.keys(items[step.id]).length) delete items[step.id];
                });
              }

              let finalItems = {};
              for (let [keys, vals] of Object.entries(items)) {
                if (vals) {
                  finalItems[keys] = vals;
                }
              }

              if (Object.keys(finalItems)?.length) {
                productCustomizationObj['bundle'][currentStepperId][productObj?.id][
                  'items'
                ] = finalItems;
              }
            }
          }

          console.log(
            'yyyyyyyyyyyyyyyyyyyyyyyyyyyy -- ',
            JSON.stringify(productCustomizationObj, null, 2)
          );
          dispatch(
            updateProductPayload({
              data: productCustomizationObj,
            })
          );
        }
      }

      if (isCustomized && !isBundleItem) {
        console.log(`4 setting unlockedStepperId to `, Number.MAX_SAFE_INTEGER);
        window.localStorage.setItem('unlockedStepperId', Number.MAX_SAFE_INTEGER);
      }

      if (isBundleItem) {
        const productCustomizationData = tempItems.data.items.find(
          (product) => product.id == mainProductId
        );
        window.localStorage.setItem('customizationData', JSON.stringify(productCustomizationData));
      }

      let state = {
        state: {
          retUrl: returnURL,
        },
      };

      if (oldLocation) {
        state['state']['oldLocation'] = oldLocation;
        state['state']['oldLocation']['retUrl'] = oldLocation.pathname;
        if (!state['state']['oldLocation']['state']) {
          state['state']['oldLocation']['state'] = {};
        }
        state['state']['oldLocation']['state']['retUrl'] = oldLocation.pathname;
        state['state']['description'] = name;
      }

      if (
        !location.pathname?.includes('deals') &&
        !(location.pathname?.includes('search') && productObj['bundleTypeId'].includes('bundle'))
      ) {
        state = {
          state: {
            oldLocation: location,
            description: `${name}`,
            retUrl: returnURL,
          },
        };
      }

      console.log(`going to - `, productRoute);

      navigate(productRoute, state);
    });
  };

  // check is button needs to be disabled
  let shouldDisabledButton;
  if (isBundleItem) {
    const productCustomization = tempItems.data.items.find(
      (product) => product.id == mainProductId
    );
    const currentStepInfo = productsMap[mainProductId]?.steps?.find(
      (step) => step?.id == currentStepperId
    );
    const currentStepProductsCount =
      Object.values(productCustomization?.['bundle']?.[currentStepperId] || {})?.reduce(
        (totalQty, product) => {
          return totalQty + (product?.notAdded ? 0 : product?.qty || 1);
        },
        0
      ) || 0;

    if (
      currentStepProductsCount >= (currentStepInfo?.maximum || 1) &&
      !Object.keys(productCustomization?.['bundle']?.[currentStepperId] || {}).includes(
        productObj?.id?.toString()
      )
    ) {
      shouldDisabledButton = true;
    } else {
      shouldDisabledButton = false;
    }
  }
  const pathSegments = location?.pathname.split('/');
  const isIncludeDeals = ['deals', 'العروض'].includes(pathSegments[2]);

  // update price is product variation was changed -
  if (productsMap[mainProductId]?.isBOGO) {
    const productCustomization = tempItems.data.items.find(
      (product) => product.id == mainProductId
    );

    let productInfo = productCustomization?.bundle?.[currentStepperId]?.[productObj?.id];
    if (!productInfo) {
      // check for the product in previous steps
      let allProducts = [];
      for (let step of Object.values(productCustomization?.['bundle'] || {})) {
        for (let [pId, pObj] of Object.entries(step)) {
          allProducts = [...allProducts, { ...pObj, id: pId }];
        }
      }
      let matches = allProducts?.filter((item) => item.id == productObj.id);
      if (matches.length) {
        let actualMatches = [];
        for (let match of matches) {
          let doesVariationExist = true;
          for (let [variantId, selectedVariant] of Object.entries(match?.variants || {})) {
            // check if this combo exists in productObj or not
            let currentVariation = productObj?.variants?.find((v) => v.id == variantId);
            let currentSelectedVariation = currentVariation?.options?.find(
              (cv) => cv.id == selectedVariant
            );
            if (!currentSelectedVariation) {
              doesVariationExist = false;
            }
          }

          if (doesVariationExist) {
            actualMatches.push(match);
          }
        }
        productInfo = actualMatches[actualMatches.length - 1] || actualMatches[0];
        productInfo = productInfo || matches[matches.length - 1] || matches[0];
      }
    }

    const variationArray = [-1, -1, -1];
    Object.values(productInfo?.variants || {}).forEach((variant, index) => {
      variationArray[index] = variant;
    });

    let currentProductVariation = productsMap[productObj?.id]?.items?.find((item) => {
      let itemInfo;
      if (item?.id) {
        itemInfo = item;
      } else {
        itemInfo = productsMap[item];
      }

      let isVariantSame = true;
      variationArray.forEach((variant, index) => {
        if (itemInfo[`sel${index + 1}Value`] != variant) {
          isVariantSame = false;
        }
      });
      return isVariantSame;
    });

    if (!currentProductVariation?.id) {
      currentProductVariation = productsMap[currentProductVariation];
    }

    if (currentProductVariation) {
      price =
        currentProductVariation?.price >= 0
          ? currentProductVariation?.price
          : currentProductVariation?.specialPrice || currentProductVariation?.originalPrice;
    }
  }

  if (buildCat && !isBundleItem) {
    return (
      <>
        <div className={css.ctaOwnPizze} onClick={handleRoute}>
          <Button color="primary" variant="contained">
            <FormattedMessage id="makeownpizza_button" />
          </Button>
        </div>
      </>
    );
  }

  return (
    <div key={keyVal} className={css.price}>
      <div
        className={ClassNames(css.priceWrapper, {
          [css.noCTA]: hideCustomize,
          [isIncludeDeals && !isDesktop ? '' : css.dealPriceWrapper]: !isDesktop && isIncludeDeals,
          [isIncludeDeals && !isDesktop ? css.nonDealPriceWrapper : '']:
            !isIncludeDeals && !isDesktop,
        })}
      >
        {!hideCustomize && (
          <a
            href={productRoute}
            className={ClassNames(css.customizeButton, {
              [css.disabledLink]: shouldDisabledButton,
            })}
            onClick={handleRoute}
          >
            <span className={css.customizeBox}>
              {isCustomized ? (
                <>
                  <FormattedMessage id="customized" defaultMessage="Customized" />
                  <div className={css.tick}>
                    <TiTick className={css.icon} />
                  </div>
                </>
              ) : (
                <>
                  <FormattedMessage id="producttiledesc_customize" defaultMessage="CUSTOMIZE" />
                  <div className={css.arrow}>
                    <BiRightArrowAlt className={css.icon} />
                  </div>
                </>
              )}
            </span>
          </a>
        )}
        <div className={css.mobilePrice}>
          {isDesktop && showStrike && strikeOutPrice > 0 ? (
            <div key={keyVal + 'strikeOut'} className={css.strikeOut}>
              <span>{decimalChecker(strikeOutPrice, 2)}</span> <span>{currency}</span>
            </div>
          ) : (
            ''
          )}
          {productObj?.bundleTypeId != 'bundle' && !productObj?.isBOGO && price > 0 && (
            <div className={css.cost}>
              <div>
                <span>{decimalChecker(price, 2)}</span> <span>{currency}</span>
              </div>
              {isDesktop && discountPercentage && (
                <div className={css.percentage}>{discountPercentage}</div>
              )}
            </div>
          )}
          {!isDesktop && showStrike && strikeOutPrice ? (
            <div key={keyVal + 'strikeOut'} className={css.strikeOut}>
              <span>{decimalChecker(strikeOutPrice, 2)}</span> <span>{currency}</span>
            </div>
          ) : (
            ''
          )}
          {!isDesktop && discountPercentage && (
            <div className={css.percentage}>{discountPercentage}</div>
          )}
        </div>
      </div>
    </div>
  );
}
